import React from 'react'
import styled from 'styled-components'

const ProfilePicture = styled.img`
  width: ${props => (props.size ? `${props.size}px` : '80px')};
  height: ${props => (props.size ? `${props.size}px` : '80px')};
  border-radius: 50%;
  object-fit: cover;
`

export default ({ src = '/icons/avatar.svg', ...props }) => (
  <ProfilePicture src={src} {...props} />
)



// WEBPACK FOOTER //
// ./src/components/ProfilePicture.js